import React from 'react';
import closeIcon from '../images/close popup.png';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import utilService from '../../../services/utilService';
import Button from '../../Button';
import PreEvaluationDetails from '../../PreEvaluationDetails';
import {BackendQueryField} from '../../../configuration/backendFileds/backendFileld.config';

const PreEvaluationPopUp = ({close, featureName, queries, save, startTraining, isCanTrain, isCanSave, featureStatus, findLabel, findAttribute}) => (
    <div className='popUp-pre-eval'>
        <div className='pre-evaluation-popup-container'>
            {close && <img className='pre-evaluation-popup-close' src={closeIcon} alt='close popup' onClick={close}/>}
            <div className='pre-evaluation-popup-inner'>
                <p className='pre-evaluation-popup-main-title'>{_SYSTEM_TITLES.PreEvaluationMainTitle}</p>
                <p className='pre-evaluation-popup-sub-title'>{_SYSTEM_TITLES.feature}</p>
                <p className='pre-evaluation-popup-feature-name'>{featureName}</p>
                <div className='pre-evaluation-popup-scroller'>
                    <div className='pre-evaluation-popup-queries-container'>
                        {queries.map((query, i) =>
                            <React.Fragment key={i}>
                                <p
                                    className='pre-evaluation-popup-queries-sub-title'>
                                    {`${utilService.removeLastChar(_SYSTEM_TITLES.classes, 3)}y`}
                                </p>
                                <PreEvaluationDetails query={query} findLabel={findLabel} findAttribute={findAttribute}/>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
            <div className='popUp-pre-eval-btns'>
                {featureStatus === 'new' && <Button
                    onClick={() => isCanSave() && save()}
                    classNameButton={isCanSave() ? 'btn-inner' : 'btn-inner show-opacity'}
                    isDisabledActive={false}
                >
                    {_SYSTEM_TITLES.validate}
                </Button>}
                <Button
                    id={_SYSTEM_TITLES.startTraining.toLowerCase().replaceAll(' ', '_')}
                    onClick={() => (!queries.some((q) => BackendQueryField.error in q) && isCanTrain) && startTraining()}
                    classNameButton={(queries.some((q) => BackendQueryField.error in q) || !isCanTrain) ? 'btn-main show-opacity' : 'btn-main'}
                    isDisabledActive={false}
                >
                    {_SYSTEM_TITLES.startTraining}
                </Button>
            </div>
        </div>
    </div>
);

export default PreEvaluationPopUp;
